import React, { useState, useCallback, useEffect } from "react";
import { getGroupCollection } from "../api/firestore/groups";

const useGroups = () => {
  const [groups, setGroups] = useState(null);

  const getGroupsFromLocal = () => {
    const groups = localStorage.getItem("groups");

    if (!groups) {
      return null;
    } else {
      let finalGroups = JSON.parse(decodeURIComponent(groups));

      if (finalGroups.timestamp < Date.now() - 3600 * 1000) {
        return null;
      } else {
        return finalGroups?.data;
      }
    }
  };

  const setGroupsLocal = (groups) => {
    let finalGroups = encodeURIComponent(
      JSON.stringify({ data: groups, timestamp: Date.now() })
    );

    localStorage.setItem("groups", finalGroups);
  };

  const groupHandler = useCallback(async () => {
    let finalGroups = getGroupsFromLocal();

    if (!finalGroups || true) {
      try {
        finalGroups = await getGroupCollection();
      } catch (e) {}

      setGroupsLocal(finalGroups);
    }

    setGroups(finalGroups);
  }, []);

  useEffect(() => {
    groupHandler();
  }, [groupHandler]);

  return groups;
};

export default useGroups;
